/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/updateBox.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_BOX } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { useBoxId } from "../provider"

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateBoxMethods extends IPluginMethodMap {
  updateBox(args: any): Promise<any>;
}

export class UpdateBoxService implements IAgentPlugin {
  readonly methods: IUpdateBoxMethods;

  constructor() {
    this.methods = {
      updateBox: this.updateBox.bind(this),
    };
  }

  async updateBox(args: any) {
    const { boxId } = useBoxId();
    log.blue(`updateBox server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_BOX,
          variables: {
            filter: {
              _id: boxId,
            },
            update: {
              ...args?.payload,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateBox,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
